var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpFromLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.656 34.344C194.531 31.219 189.469 31.219 186.344 34.344L34.344 186.344C32.781 187.906 32 189.938 32 192S32.781 196.094 34.344 197.656C37.469 200.781 42.531 200.781 45.656 197.656L184 59.312V376C184 380.406 187.578 384 192 384S200 380.406 200 376V59.312L338.344 197.656C341.469 200.781 346.531 200.781 349.656 197.656S352.781 189.469 349.656 186.344L197.656 34.344ZM376 464H8C3.582 464 0 467.582 0 472S3.582 480 8 480H376C380.418 480 384 476.418 384 472S380.418 464 376 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFromLine);
export default __webpack_public_path__ + "static/media/arrow-up-from-line.284692cc9be13a2d5ace00d6f77d6a66.svg";
export { ForwardRef as ReactComponent };